import { render, staticRenderFns } from "./TabelaPepPf.vue?vue&type=template&id=0df93f42&lang=pug"
import script from "./TabelaPepPf.vue?vue&type=script&lang=js"
export * from "./TabelaPepPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaPepPf.vue?vue&type=style&index=0&id=0df93f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports